
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError, of, throwError } from 'rxjs';
import { catchError, delay, map, publishReplay, refCount, retry, mergeMap, tap } from 'rxjs/operators';
import { Constants } from '@constants/constants';
import { DsconfigService } from '../dsconfig/dsconfig.service';
import { ErrorService } from '../error/error.service';
import { LoadingService } from '../loading/loading.service';
import { StorageService } from '../storage/storage.service';
import { TranslateService } from '@ngx-translate/core';

enum methods {
  'get',
  'post',
  'put',
  'patch',
  'delete'
}

/**
 * Elementos posibles que pueden llegar al restconn como propiedades
 * loading Activa la carga parcial del loading (se incorpora con <app-loading name="<name>">)
 * lock Activa el bloqueo de página del loading
 * cache Habilita la cache en la llamada, haciendo se consuma el observable previo
 * retry Numero de veces que se ha de repetir la llamada si esta falla
 * forceWarning Si viene algun error lo gestionará siempre como warnings
 * disableErrors fuerza que no se gestione ningun error mediante el sistema de errores por defecto
 * errPrefix Prefijo que le va a poner al sistema de errores para intanciarlo
 * collection Objeto que va a contener ids y valores de las urls que se van a consumir
 * headers inyecta cabeceras a las llamadas
 */
interface PropertiesRestConn {
  loading?: boolean;
  lock?: boolean;
  cache?: boolean;
  retry?: number;
  collection?: object;
  forceWarning?: boolean;
  disableErrors?: boolean;
  errPrefix?: string;
  headers?: object;
  delay?: number;
  responseType?: string;
  schema?: object;
}

/**
 * Sistema para realizar llamadas rest sincronizadas con loading and error services
 */
@Injectable()
export class RestConnService {

  // isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

  collection: Object;
  // httpOptions;
  type: methods;
  headers: object;
  customer: any;
  token: any;
  sessionId: string;
  xclient: string;
  appinit: string;
  ajv: any;
  headerEmail: string;
  headerProfileId: string;
  headerEmployeeNumber: string;
  headerEmployeeName: string;

  constructor(
    public _http: HttpClient,
    public loading: LoadingService,
    public err: ErrorService,
    public router: Router,
    public storage: StorageService,
    public dsConfig: DsconfigService
    , public translate: TranslateService
  ) {

    this.collection = {};
    this.customer = this.storage.get(Constants.UserData.CUSTOMER);
    this.token = this.storage.get(Constants.UserData.TOKEN);
    this.sessionId = this.storage.get(Constants.UserData.sid);
    //console.log("estableciendo headers en el constructor!!! con los siguientes valores:");
    this.headerEmail = this.storage.get(Constants.UserData.email) || null;
    this.headerProfileId = this.storage.get(Constants.UserData.profileId) || null;
    this.headerEmployeeNumber = this.storage.get(Constants.UserData.employeeNumber) || null;
    this.headerEmployeeName = this.storage.get(Constants.UserData.employeeName) || null;

    // console.log("constructor - headerEmail",this.headerEmail);
    // console.log("constructor - headerProfileId",this.headerProfileId);
    // console.log("constructor - headerEmployeeNumber",this.headerEmployeeNumber);
    // console.log("constructor - headerEmployeeName",this.headerEmployeeName);


  }


  public setHeader(propertyRef: PropertiesRestConn) {
    const content_type = propertyRef.responseType ? 'application/x-www-form-urlencoded' : 'application/json';

    // tslint:disable-next-line:max-line-length
    this.headers = {
      'Content-Type': propertyRef.headers && propertyRef.headers['Content-Type'] ?
        propertyRef.headers['Content-Type'] :
        content_type,
      'Authorization': 'Bearer ' + this.token,
    };

    //console.log("estableciendo headers en el método setHeader!!! con los siguientes valores:");
    this.headerEmail = this.storage.get(Constants.UserData.email) || null;
    this.headerProfileId = this.storage.get(Constants.UserData.profileId) || null;
    this.headerEmployeeNumber = this.storage.get(Constants.UserData.employeeNumber) || null;
    this.headerEmployeeName = this.storage.get(Constants.UserData.employeeName) || null;

    if (this.headerEmail) { this.headers['email'] = this.headerEmail }
    if (this.headerProfileId) { this.headers['profileId'] = this.headerProfileId.toString() }
    if (this.headerEmployeeNumber) { this.headers['employeeNumber'] = this.headerEmployeeNumber.toString() }
    if (this.headerEmployeeName) { this.headers['name'] = this.headerEmployeeName }

    // console.log("setHeader - headerEmail",this.headerEmail);
    // console.log("setHeader - headerProfileId",this.headerProfileId);
    // console.log("setHeader - headerEmployeeNumber",this.headerEmployeeNumber);
    // console.log("setHeader - headerEmployeeName",this.headerEmployeeName);

  }

  public getHeader() {
    return this.headers;
  }

  /**
   * Redirección a la página de login
   */
  public logout() {
    if (window.location.hostname === 'localhost') {
      window.location.href = '/time-recording/'; return;
    } else {
      // window.location.href = '/assets/lanzadera.html'; return;
    }
  }

  /**
   * Genera un id en base a la url a consumir y los parametros que se le envian a ese id
   * @param toReturnRef Este concuadra con el objeto que devuelve analyceProp, ha de contener ".url"
   * @param data Array de los parametros que se le envian
   */
  public generateId(toReturnRef, data, properties) {
    return toReturnRef.url + JSON.stringify(data) + JSON.stringify(properties) + JSON.stringify(this.headers);

  }
  public generateIdExportFile(toReturnRef, data, properties) {
    return toReturnRef.url + data + JSON.stringify(properties) + JSON.stringify(this.headers);
  }


  /**
   * Función que analiza y prepara todos las opciones de la llamada rest
   * @param name id del servicio (que se va a consumir de constants.restConn o de la collection pasada en propertyRef)
   * @param propertyRef Interface PropertiesRestConn
   * @param data parametros que se envian en la llamada
   */
  private analyceProp(name, propertyRef: PropertiesRestConn, data, archivo: boolean) {
    if (typeof propertyRef !== 'object') {
      propertyRef = {};
    }

    let toReturn = { // tslint:disable-line
      url: '',
      id: '',
      error: false, // errores internos de proceso de datos
      lock: false,
      loading: false,
      forceWarning: false,
      disableErrors: false,
      retry: 0, // Sync with the value of the config file
      errPrefix: 'COMMON.CUSTOM_ERRORS.',
      cache: propertyRef.cache || false,
      headers: null,
      httpOptions: null,
      delay: 0,
      schema: null
    };

    this.token = this.storage.get(Constants.UserData.TOKEN);
    this.sessionId = this.storage.get(Constants.UserData.sid);

    // this.xclient = this.dsConfig.get()[Constants.UserData.xclient];
    // this.appinit = this.dsConfig.get()[Constants.UserData.appinit];
    this.setHeader(propertyRef);
    toReturn.headers = Object.assign({}, this.headers);
    if (typeof propertyRef.headers === 'object') {
      Object.assign(toReturn.headers, propertyRef.headers);
      // for (const [headerTempKey, headerTempValue] of Object.entries(propertyRef.headers)) {
      //   this.headers.append(headerTempKey, headerTempValue);
      // }
    }
    toReturn.httpOptions = { headers: new HttpHeaders(toReturn.headers), observe: 'response' };


    if (propertyRef.responseType) {
      toReturn.httpOptions.responseType = propertyRef.responseType;
    }

    if (typeof propertyRef.retry === 'number') {
      toReturn.retry = propertyRef.retry;
    }

    if (propertyRef.errPrefix) {
      toReturn.errPrefix = propertyRef.errPrefix;
    }

    if (propertyRef.forceWarning) {
      toReturn.forceWarning = true;
    }
    if (propertyRef.disableErrors) {
      toReturn.disableErrors = true;
    }

    if (propertyRef.delay) {
      toReturn.delay = propertyRef.delay;
    }

    if (propertyRef.lock) {
      toReturn.lock = true;
      this.loading.fullPageOpen(name);
    } else if (propertyRef.loading) {
      toReturn.loading = true;
      this.loading.partialLoadingOpen(name);
    }
    this.err.removeWarning(name);

    if (typeof propertyRef.collection !== 'object') {
      propertyRef.collection = {};
    }

    if (propertyRef.collection[name] === undefined) {
      if (this.dsConfig.getRoute(name) === undefined) {
        this.err.logError('No se reconoce el nombre de la llamada rest en el repositorio: ' + name);
        toReturn.error = true;
      } else {
        toReturn.url = this.dsConfig.getRoute(name);
      }
    } else {
      toReturn.url = propertyRef.collection[name];
    }

    if (archivo) {
      toReturn.id = this.generateIdExportFile(toReturn, data, propertyRef);
    }else{
      toReturn.id = this.generateId(toReturn, data, propertyRef);
    }

    if (propertyRef.schema) {
      toReturn.schema = propertyRef.schema;
    }

    return toReturn;
  }

  private finishFuncionality(nameRef, propertiesExec, response) {
    if (propertiesExec.lock) {
      this.loading.fullPageClose(nameRef);
    } else if (propertiesExec.loading) {
      this.loading.partialLoadingClose(nameRef);
    }

    if (response.status && response.status === 200) {
      // response = response.json();
      response = response.body;
      return true;
    }
    return false;
  }

  getHttpRequest(method, name, url, data = null): HttpRequest<object> {
    if (methods[method] === 'get') {
      return new HttpRequest<object>(methods[method], url, { params: data });
    } else {
      return new HttpRequest<object>(methods[method], url, data, { params: null });
    }
  }


  /**
   * Devuelve un observable standard de las llamadas
   * @param method metodo por el que se va a realizar (es un enum de methods que contiene GET POST y PUT)
   * @param name id del servicio
   * @param propertiesExec PropertiesRestConn ya analizado
   * @param data Parametros a enviar en la llamada rest
   * @returns Observable para suscribirse a la llamada rest
   */
  private getStandardRequest(method, name, propertiesExec, data): Observable<any> {
    let paramsToSend: Array<any>;
    if (methods[method] === 'get') {
      let toSend = '';
      if (typeof data === 'string' || typeof data === 'number') {
        toSend = '/' + data;
        propertiesExec.url += toSend;
      } else {
        propertiesExec.httpOptions.params = data;
      }
      paramsToSend = [propertiesExec.url, propertiesExec.httpOptions];
    } else {
      paramsToSend = [propertiesExec.url, data, propertiesExec.httpOptions];
    }


    return this._http[methods[method]](...paramsToSend)
      .pipe(this.validateResp(propertiesExec.schema),
        delay(propertiesExec.delay),
        map((res: any) => {
          return this.checkSuccessErrors(name, propertiesExec, res);
        }),
        retry(propertiesExec.retry),
        catchError((error: any) => {
          return this.checkFailedErrors(name, propertiesExec, error);

        }));
  }

  private gotoErrorPage(page, refJson) {

    this.loading.fullPageClose('AppModule');
    this.router.navigate([page], { queryParams: refJson, skipLocationChange: true });
  }

  /**
   * Función que modifcia el observable de getStandardRequest e incorpora la finilizacion de la funcionalidad
   * Esta modificación se realiza principalmente para las llamadas con cache
   * @param method metodo por el que se va a realizar (es un enum de methods que contiene GET POST y PUT)
   * @param name id del servicio
   * @param data Parametros a enviar en la llamada rest
   * @param properties interface PropertiesRestConn
   */
  private makeRest(method: methods, name, data: object, properties: PropertiesRestConn) {
    // name = name.replace(/xls/g, '').replace(/pdf/g, '');
    const propertiesExec = this.analyceProp(name, properties, data, false);
    this.loading.setHasLoadings(name);
    if (!propertiesExec.error) {
      if (!propertiesExec.cache) {
        // reasignacion de la llamada sin cache
        this.collection[propertiesExec.id] = this.getStandardRequest(method, name, propertiesExec, data);
      } else if (!this.collection[propertiesExec.id]) {
        // asignacion inicial de la llamada con cache
        this.collection[propertiesExec.id] = this.getStandardRequest(method, name, propertiesExec, data).pipe(publishReplay(1), refCount());
      } else {
        // si llamada con cache ya realizada
        this.finishFuncionality(name, propertiesExec, true);
      }
      return this.collection[propertiesExec.id];
    }
  }

  private makeRestFilter(method: methods, name, data: object, properties: PropertiesRestConn) {
    // name = name.replace(/xls/g, '').replace(/pdf/g, '');
    const propertiesExec = this.analyceProp(name, properties, data, true);
    this.loading.setHasLoadings(name);
    if (!propertiesExec.error) {
      if (!propertiesExec.cache) {
        // reasignacion de la llamada sin cache
        this.collection[propertiesExec.id] = this.getStandardRequest(method, name, propertiesExec, data);
      } else if (!this.collection[propertiesExec.id]) {
        // asignacion inicial de la llamada con cache
        this.collection[propertiesExec.id] = this.getStandardRequest(method, name, propertiesExec, data).pipe(publishReplay(1), refCount());
      } else {
        // si llamada con cache ya realizada
        this.finishFuncionality(name, propertiesExec, true);
      }
      return this.collection[propertiesExec.id];
    }
  }

  /**
   * Realiza una llamada GET
   * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
   * @param data parametros a enviar
   * @param properties interface PropertiesRestConn
   */
  public get(name, data, properties: PropertiesRestConn): any {
    return this.makeRest(methods.get, name, data, properties);
  }

  /**
   * Realiza una llamada POST
   * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
   * @param data parametros a enviar
   * @param properties interface PropertiesRestConn
   */
  public post(name: string, data, properties: PropertiesRestConn) {
    return this.makeRest(methods.post, name, data, properties);
  }
    /**
   * Realiza una llamada POST
   * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
   * @param data parametros a enviar
   * @param properties interface PropertiesRestConn
   */
     public postFile(name: string, data, properties: PropertiesRestConn) {
      return this.makeRestFilter(methods.post, name, data, properties);
    }

  /**
   * Realiza una llamada PUT
   * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
   * @param data parametros a enviar
   * @param properties interface PropertiesRestConn
   */
  public put(name: string, data, properties: PropertiesRestConn) {
    return this.makeRest(methods.put, name, data, properties);
  }

  /**
   * Realiza una llamada PATCH
   * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
   * @param data parametros a enviar
   * @param properties interface PropertiesRestConn
   */
  public patch(name: string, data, properties: PropertiesRestConn) {
    return this.makeRest(methods.patch, name, data, properties);
  }

  /**
 * Realiza una llamada DELETE
 * @param name id de la llamada (contenida en Constans.restConn o una coleccion pasada por properties)
 * @param data parametros a enviar
 * @param properties interface PropertiesRestConn
 */
  public delete(name: string, data, properties: PropertiesRestConn) {
    return this.makeRest(methods.delete, name, data, properties);
  }


  public checkSuccessErrors(name, propertiesExec, res) {
    let response = [];
    this.loading.deleteHasLoadings(name);
    const finish = this.finishFuncionality(name, propertiesExec, res);
    if (finish && typeof res.body === 'object') {
      const refJson = res.body;

      if (refJson && refJson.type && refJson.type === 'warning') {
        // Quieren saber el error que da el código 1 por tealium antes de sobreescribirlo nosotros con un error genérico US-5654
        if (refJson.code === '1') {
          refJson.code = 'ERRGEN';
        }
        // WARNING DIRECTO
        // tslint:disable-next-line:max-line-length
        this.err.addWarning(name, ((refJson.code && refJson.code !== '1') ? propertiesExec.errPrefix + refJson.code : (refJson.message ? refJson.message : null)), refJson.code !== '1');
        // this.err.addCustomError(name, (refJson.code ? propertiesExec.errPrefix + refJson.code : (refJson.message ? refJson.message : null)));

      } else if (refJson && refJson.type && refJson.type === 'error') {
        // ERROR DIRECTO
        if (propertiesExec.forceWarning) {
          // tslint:disable-next-line:max-line-length
          this.err.addWarning(name, ((refJson.code && refJson.code !== '1') ? propertiesExec.errPrefix + refJson.code : (refJson.message ? refJson.message : null)), refJson.code !== '1');
        } else {
          if (!propertiesExec.disableErrors) {
            // TODO: Quitar esto cuando los errores de code = '1' esten controlados
            if (refJson.code === '1') {
              refJson.code = 'ERRGEN';
            }
            let myCode;
            try {
              myCode = refJson.code;
              if (!myCode) {
                myCode = 'server';
              }
            } catch (err) {
              myCode = 'server';
            }
            this.err.addCustomError(name, refJson);
            // this.gotoErrorPage('/error/' + myCode, refJson);
          } else if (refJson.code) {
            // if (!propertiesExec.disableErrors) {
            //   this.err.addCustomError(name, refJson);
            // }
            // this.gotoErrorPage('/error/' + refJson.code, refJson);
            // }
          }
        }

      } else if (refJson && refJson.errors) {
        // NO CONTROLADO EL TYPE
        if (propertiesExec.forceWarning) {
          this.err.addWarning(name, (refJson.code && refJson.code !== '1') ? propertiesExec.errPrefix + (refJson.code ? refJson.code : null) : (refJson.message ? refJson.message : null), refJson.code !== '1');
        } else {
          if (propertiesExec.disableErrors) {
            // this.err.addWarning(name, (refJson.code && refJson.code !== '1') ? propertiesExec.errPrefix + (refJson.code ? refJson.code : null) : (refJson.message ? refJson.message : null), refJson.code !== '1');
          } else {
            // this.err.addCustomError(name, propertiesExec.errPrefix + (refJson.code ? refJson.code : null));
            this.gotoErrorPage('/error/server', refJson);
          }
        }
      }
      // this.refreshIE();
      response = refJson;
    }
    return response;
  }

  public checkFailedErrors(name, propertiesExec, error) {
    this.loading.deleteHasLoadings(name);
    const finish = this.finishFuncionality(name, propertiesExec, error);
    const response = [];
    // tslint:disable-next-line:prefer-const
    let propertyFindError: any = this.searchSavedError(error);

    if (error.schema) {
      this.err.addCustomError(name, { code: 'ERRGEN' });
    } else if (propertiesExec.forceWarning) {
      if (error.status) {
        this.err.addWarning(name, propertiesExec.errPrefix + error.status);
      } else {
        this.err.addWarning(name, 'COMMON.CUSTOM_ERRORS.ERRGEN');
      }
    } else if (propertyFindError && propertyFindError.find) {
      // tslint:disable-next-line:prefer-const
      let refJson = { response: propertyFindError.response };
      response.push(refJson);
      return response;
    } else if (!propertiesExec.disableErrors) {
      if (error.status) {
        switch (error.status) {
          case 401:
            /** Changes behaviour when request sends 401, redirects to login */
            window.location.href = '/login/';
            break;
          case 500:
            this.gotoErrorPage('/error/internal', {});
            break;
          case 408:
          case 409:
          case 503:
          case 504:
          case 403:
          default:
            if (!propertiesExec.forceWarning) {
              this.gotoErrorPage('/error/server', error.status);
            } else {
              this.err.addWarning(name, propertiesExec.errPrefix + error.status);
            }
            break;
        }
        this.loading.partialLoadingClose(name);
      } else {
        this.gotoErrorPage('/error/server', {});
      }
    }
    return observableThrowError(error || 'Server error');
  }

  searchSavedError(error) {
    let response1 = {};
    if (Array.isArray(error.error)) {
      if (this.translate.instant('ERRORS.' + error.error[0].code)) {
        response1 = {
          find: true, response: error.error[0].code
        };
        return response1;
      } else {
        response1 = {
          find: false, response: ''
        };
      }
    } else {
      if (this.translate.instant('ERRORS.' + error.error.code)) {
        if (error.error.type) {
          response1 = {
            find: true, response: error.error.type
          };
        }
        response1 = {
          find: true, response: error.error.code
        };
        return response1;
      } else {
        response1 = {
          find: false, response: ''
        };
      }
    }
  }

  public downloadResource(url: string) {
    return this._http.get(url, { responseType: 'blob' as 'json' });
  }

  private validateResp(
    schema: object
  ): (obs: Observable<any>) => Observable<any> {
    return (obs: Observable<any>) => obs.pipe(tap(resp => {
      if (schema && !resp.body.type && this.ajv && !this.ajv.validate(schema, resp.body)) {
        throw { schema: this.ajv.errors };
      }
    }));
  }

}
